// What a payment route answered, read the same way on the dues and band pages.
//
// A completion that answers { pending: true } (HTTP 202) may already have collected the
// money and is still being confirmed by the AU office: the page must show that and must
// not offer Pay again. A 400 from a completion is a definite refusal of that order, so a
// retry starts a new order. Anything else (no answer, a 5xx) may hide a payment that went
// through, so the page keeps the same order and the server's repeat check answers the
// real state on the retry.

export const PAYMENT_PENDING_TEXT =
  'Your payment is still being confirmed. Please do not pay again. The AU office will confirm it.'

type ErrorShape = { response?: { status?: number; data?: { error?: unknown; pending?: unknown } } }

function response(err: unknown): ErrorShape['response'] {
  return (err as ErrorShape | null | undefined)?.response
}

/** The server's refusal text, when the error carries one. */
export function serverError(err: unknown): string | undefined {
  const message = response(err)?.data?.error
  return typeof message === 'string' && message !== '' ? message : undefined
}

/** True when the server definitely refused this order (HTTP 400). */
export function isDefiniteRefusal(err: unknown): boolean {
  return response(err)?.status === 400
}

/**
 * A start route's 409 { pending: true }: an earlier payment is still being confirmed.
 * Returns its message, or null for any other error.
 */
export function pendingRefusal(err: unknown): string | null {
  const r = response(err)
  if (r?.status !== 409 || r.data?.pending !== true) return null
  return serverError(err) ?? PAYMENT_PENDING_TEXT
}
